import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from 'vue'

import type { OnboardingSubject } from '@/models/onboarding.personalization'
import { QuestionnaireView } from '@/models/onboarding'
import type {
  DynamicOptionsPage,
  QuestionnaireFormOption,
} from '@/models/onboarding.types'

import Layout from '../Layout.vue'
import OptionsBody from './OptionsBody.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicOptions',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => props.view.currentPage as DynamicOptionsPage)

const optionsBodyPage = computed(() => ({
  multipleOptions: false as const,
  maxOptions: undefined,
  centerText: undefined,
  wrapInputs: undefined,
  image: undefined,
}))

const subjectKey = computed((): OnboardingSubject => {
  const selectedSubject =
    props.view.getUserChoice<string>(page.value.sourcePageId) ??
    page.value.defaultSourceSubject
  return selectedSubject as OnboardingSubject
})

const resolvedOptions = computed((): QuestionnaireFormOption[] => {
  const labels = page.value.optionsBySubject[subjectKey.value] ?? []
  return labels.map((label) => ({ label }))
})

const selectedOptions = ref<string[]>([])

watch(selectedOptions, (newValue) => {
  props.view.setCurrentChoice(newValue[0])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    id: page.value.id,
    class: "onboarding-options",
    title: page.value.title,
    subtitle: page.value.subtitle,
    scrollDefaultSlot: true,
    reverseTitleSubtitle: true
  }, {
    default: _withCtx(() => [
      _createVNode(OptionsBody, {
        modelValue: selectedOptions.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOptions).value = $event)),
        page: optionsBodyPage.value,
        options: resolvedOptions.value
      }, null, 8, ["modelValue", "page", "options"])
    ]),
    _: 1
  }, 8, ["id", "title", "subtitle"]))
}
}

})